export function writeToClipboard(text) {
  navigator.clipboard.writeText(text);
}

export async function readFromClipboard() {
  return await navigator.clipboard.readText();
}
